"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _LiveHelp = _interopRequireDefault(require("@material-ui/icons/LiveHelp"));

var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//material-ui
//icons
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      position: 'absolute',
      bottom: 0,
      right: theme.spacing(2)
    }
  };
});

var UtilityIcon = function UtilityIcon(props) {
  var classes = useStyles();
  var handleDrawer = props.handleDrawer,
      helpGuidePath = props.helpGuidePath,
      setOpenHelpGuide = props.setOpenHelpGuide;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, helpGuidePath && helpGuidePath.length && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    key: "0",
    onClick: function onClick() {
      return setOpenHelpGuide(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_LiveHelp.default, null)), handleDrawer && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    key: "1",
    onClick: handleDrawer
  }, /*#__PURE__*/_react.default.createElement(_Settings.default, null)));
};

var _default = UtilityIcon;
exports.default = _default;